


































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'


@Component
export default class Edit extends Vue {
  @Prop()
  private value!: VoiceData & {id: string}

  private tagList: string[] = []
  private isLoading = false

  private update() {
    this.isLoading = true
    const id = this.value.id
    delete this.value.id
    this.$emit('update', id, this.value)
  }

  @Watch('value')
  private onChangeValue() {
    this.isLoading = false
  }

}
